var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-9 {\n        fill: #d65b3a;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-12 {\n        fill: #c14d36;\n      }\n\n      .cls-13 {\n        fill: #9b3d2d;\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-13);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 323.69,
    y1: 520.99,
    x2: 789.34,
    y2: 520.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb7a0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b60000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 343.44,
    x2: 809.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 206.44,
    y1: 654.69,
    x2: 255.72,
    y2: 654.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc3700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 180.42,
    y1: 588.06,
    x2: 291.18,
    y2: 588.06,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 267.47,
    y1: 521.14,
    x2: 335.94,
    y2: 521.14,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 120.46,
    y1: 521.14,
    x2: 229.54,
    y2: 521.14,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 229.55,
    y1: 454.22,
    x2: 309.61,
    y2: 454.22,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 309.06,
    y1: 387.29,
    x2: 355.56,
    y2: 387.29,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 197.28,
    y1: 387.29,
    x2: 241.44,
    y2: 387.29,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 363.18,
    y1: 520.99,
    x2: 927.95,
    y2: 520.99,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 753.17,
    y1: 400.28,
    x2: 772.51,
    y2: 400.28,
    gradientTransform: "translate(9.39 -17.41) rotate(1.32)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 753.17,
    y1: 641.71,
    x2: 772.51,
    y2: 641.71,
    gradientTransform: "translate(105.86 -108.02) rotate(8.7)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 873.88,
    y1: 520.99,
    x2: 893.22,
    y2: 520.99,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 632.45,
    y1: 520.99,
    x2: 651.79,
    y2: 520.99,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 749.92,
    y1: 500.27,
    x2: 797.69,
    y2: 500.27,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 281.74,
    x2: 350.21,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g82479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g77697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54730",
    className: "cls-16",
    d: "M389.31,370.56c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h141.19c9.27,0,16.73,7.46,16.73,16.73s-7.46,16.73-16.73,16.73h-190.08c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h137.98c9.27,0,16.73,7.46,16.73,16.73s-7.46,16.73-16.73,16.73h-106.46c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h137.62c9.27,0,16.73,7.46,16.73,16.73s-7.46,16.73-16.73,16.73h-159.39c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h201.71c9.27,0,16.73,7.46,16.73,16.73,0,8.27-5.96,15.07-13.83,16.44h-176.65c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h394.48c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73h-78.76c-67.44-54.38-127.41-163.61-78.82-233.93h63.8c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73H389.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g77044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54748",
    className: "cls-1",
    d: "M409.05,370.56c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h141.19c9.27,0,16.73,7.46,16.73,16.73s-7.46,16.73-16.73,16.73h-190.08c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h137.98c9.27,0,16.73,7.46,16.73,16.73s-7.46,16.73-16.73,16.73h-106.46c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h137.62c9.27,0,16.73,7.46,16.73,16.73s-7.46,16.73-16.73,16.73h-159.39c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h201.71c9.27,0,16.73,7.46,16.73,16.73,0,8.27-5.96,15.07-13.83,16.44h-176.65c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h394.48c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73h-78.76c-67.44-54.38-127.41-163.61-78.82-233.93h63.8c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73H409.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g77033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path73784",
    className: "cls-15",
    d: "M223.17,637.96c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h15.82c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73h-15.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73782",
    className: "cls-17",
    d: "M197.15,571.33c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h77.3c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73h-77.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M319.21,504.41h-15.27c-.76,0-1.51,.07-2.24,.17-.73-.1-1.48-.17-2.24-.17h-15.27c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h15.27c.76,0,1.51-.07,2.24-.17,.73,.1,1.48,.17,2.24,.17h15.27c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73778",
    className: "cls-5",
    d: "M137.19,504.41c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h75.63c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73h-75.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73776",
    className: "cls-11",
    d: "M246.28,437.48c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h46.6c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73h-46.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73774",
    className: "cls-18",
    d: "M325.79,370.56c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h13.04c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73h-13.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73772",
    className: "cls-14",
    d: "M214.01,370.56c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h10.71c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73h-10.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54764",
    className: "cls-7",
    d: "M762.84,355.88c-23.4,.04-46.52,5.04-67.83,14.69H428.79c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h141.19c9.27,0,16.73,7.46,16.73,16.73s-7.46,16.73-16.73,16.73h-190.08c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h137.98c9.27,0,16.73,7.46,16.73,16.73s-7.46,16.73-16.73,16.73h-106.46c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h137.62c9.27,0,16.73,7.46,16.73,16.73s-7.46,16.73-16.73,16.73h-159.39c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h201.71c9.27,0,16.73,7.46,16.73,16.73,0,8.27-5.96,15.07-13.83,16.44h-176.65c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h277.39c21.31,9.65,44.43,14.65,67.83,14.69,91.19,0,165.11-73.92,165.11-165.11,0-91.19-73.92-165.11-165.11-165.11h0Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "circle54766",
    className: "cls-2",
    cx: 762.84,
    cy: 520.99,
    r: 140.52,
    transform: "translate(-144.97 692) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g54772"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle54768",
    className: "cls-6",
    cx: 762.84,
    cy: 400.28,
    r: 9.67,
    transform: "translate(-8.99 17.62) rotate(-1.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle54770",
    className: "cls-19",
    cx: 762.84,
    cy: 641.71,
    r: 9.67,
    transform: "translate(-88.3 122.79) rotate(-8.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g54778"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle54774",
    className: "cls-20",
    cx: 883.55,
    cy: 520.99,
    r: 9.67
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle54776",
    className: "cls-4",
    cx: 642.12,
    cy: 520.99,
    r: 9.67
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect54788",
    className: "cls-9",
    d: "M769.81,523.09l29.91,45.38c1.88,2.85,1.09,6.68-1.76,8.56h0c-2.85,1.88-6.68,1.09-8.56-1.76l-29.91-45.38c-1.88-2.85-1.09-6.68,1.76-8.56h0c2.85-1.88,6.68-1.09,8.56,1.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g61212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect61204",
    className: "cls-13",
    d: "M752.87,516.34l-21.43-83.95c-.97-3.81,1.33-7.68,5.14-8.66h0c3.81-.97,7.68,1.33,8.66,5.14l21.43,83.95c.97,3.81-1.33,7.68-5.14,8.66h0c-3.81,.97-7.68-1.33-8.66-5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect61206",
    className: "cls-12",
    d: "M753.31,515.65l-14.48-85.43c-.66-3.88,1.95-7.55,5.83-8.21h0c3.88-.66,7.55,1.95,8.21,5.83l14.48,85.43c.66,3.88-1.95,7.55-5.83,8.21h0c-3.88,.66-7.55-1.95-8.21-5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect61208",
    className: "cls-9",
    d: "M753.82,514.98l-7.17-86.35c-.33-3.92,2.59-7.36,6.5-7.68h0c3.92-.33,7.36,2.59,7.68,6.5l7.17,86.35c.33,3.92-2.59,7.36-6.5,7.68h0c-3.92,.33-7.36-2.59-7.68-6.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M796.87,570.66l-23.99-41.55c1.8-2.22,2.88-5.04,2.88-8.12,0-5.06-2.92-9.43-7.16-11.55v-81.72c0-3.93-3.19-7.12-7.12-7.12s-7.12,3.19-7.12,7.12v83.53c-2.72,2.37-4.45,5.85-4.45,9.74,0,6.62,4.99,12.08,11.41,12.83l24.84,43.02c1.71,2.95,5.48,3.97,8.44,2.26,2.95-1.71,3.97-5.48,2.26-8.44Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M333.48,637.96h-15.27c-.76,0-1.51,.07-2.24,.17-.73-.1-1.48-.17-2.24-.17h-15.27c-9.27,0-16.73,7.46-16.73,16.73s7.46,16.73,16.73,16.73h15.27c.76,0,1.51-.07,2.24-.17,.73,.1,1.48,.17,2.24,.17h15.27c9.27,0,16.73-7.46,16.73-16.73s-7.46-16.73-16.73-16.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.a975e1c0d49087b4f6523911fdc1f1ae.svg";
export { ForwardRef as ReactComponent };